<template>
  <div style="background: #fff;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName"  @tab-click="changeTab(activeName)">
      <el-tab-pane label="My Account" name="My Account" style="position: relative;">
        <Myaccount @changeTab="changeTab"></Myaccount>
      </el-tab-pane>
      <el-tab-pane label="Account Profile" name="Account Profile">
        <Accountprofile></Accountprofile>
      </el-tab-pane>
      <el-tab-pane label="Address Book" name="Address Book">
        <Address></Address>
      </el-tab-pane>
      <el-tab-pane label="Order History" name="Order History">
        <Orderhistory></Orderhistory>
      </el-tab-pane>
      <el-tab-pane label="Saved Lists" name="Saved Lists">
        <Savedlists></Savedlists>
      </el-tab-pane>
      <el-tab-pane label="Tax Certificates" name="Tax Certificates">
        <Taxcertificates></Taxcertificates>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
    import Myaccount from "./PersonaComponents/Myaccount";
    import Accountprofile from "./PersonaComponents/Accountprofile";
    import Address from "./PersonaComponents/Address";
    import Orderhistory from "./PersonaComponents/Orderhistory";
    import Savedlists from "./PersonaComponents/Savedlists";
    import Taxcertificates from "./PersonaComponents/Taxcertificates";
    export default {
        name: 'Personalinformation',
        components: {
          Myaccount,
          Accountprofile,
          Address,
          Orderhistory,
          Savedlists,
          Taxcertificates
        },
        created(){
          this.query = this.$route.query || {};
          if(this.query.tab){
            this.changeTab(this.query.tab)
          }else{
            const tab = window.sessionStorage.getItem('person-tab');
            if(tab){
              this.changeTab(tab);
            }
          }
        },
        data () {
            return {
              activeName: 'My Account',
              query:{}
            }
        },
        methods: {
          // 切换tab
          changeTab(tab) {
            this.activeName = tab;
            window.sessionStorage.setItem('person-tab',tab);
          }
        },
        // 离开页面方法
        beforeRouteLeave(to, from, next) {
          window.sessionStorage.removeItem('person-tab');
          next()
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
::v-deep .el-tabs__header{
  margin:0;
}
::v-deep .el-tabs__nav {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 96%;
  padding:0 2%;
  height:60px;
  line-height:60px;
  background:#eeeeee;
  font-size:24px;
}
::v-deep .el-tabs__item {
  width:16%;
  text-align:center;
  padding: 0 !important;
  font-size: 24px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}
::v-deep .el-tabs__item.is-active {
  color:#00546a;
}
::v-deep .el-tabs__active-bar {
  height: 0;
  background: #eeeeee;
  font-size:24px;
}
::v-deep .el-tabs__item:hover {
  color:#00546a;
}
.arrow {
  width: 0 !important;
  border: 10px solid;
  border-color: red transparent transparent transparent;
  display:flex;
  justify-content: center;
  align-items: center;
  position:absolute;
  left:50%;
  top:60px;
}
</style>